import { yupResolver } from "@hookform/resolvers/yup"
import React from "react"
import FormHead from "../../components/headings/FromHead"
import Modal from "../../components/modal"
import * as Yup from "yup"
import { useForm } from "react-hook-form"
import { MultiDropDownInput } from "../../wrappers/multiselectInput"
import Button from "../../components/button"

export type AddEmailForm = {
  toEmail: any
}

interface Props {
  onClose: any
  ClickHandler: any
  emailList: any
}

const validationSchema = Yup.object({});

const AddToEmail: React.FC<Props> = ({ onClose, ClickHandler, emailList }) => {
  
  const formOptions = {
    resolver: yupResolver(validationSchema),
  }

  const { register, handleSubmit, control, formState } = useForm<AddEmailForm>(formOptions)

  return (
    <>
    <Modal title={"Add to Email"} size="small" onClose={onClose}>
      <form>
        <FormHead>Add User</FormHead>
        <div className="form-group">
          <MultiDropDownInput<AddEmailForm>
            name="toEmail"
            register={register}
            errors={formState.errors}
            label="Add To Emails*"
            placeholder="Add emails"
            control={control}
            data={emailList}
          />
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit(ClickHandler)}>Save</Button>
        </div>
      </form>
    </Modal>
    </>
  )
}
export default AddToEmail
